
import axios from "axios"

////////////////ignore, unfinished integration
const lawpayService={}
lawpayService.logTest=(testo)=>{
    console.log(testo)
}

lawpayService.getJwt=()=>{
    {
        const config = {
          method: "GET",
          url:`http://localhost:5000/api/v1/lawpay/getJwt`,
          data: null,
          crossdomain: true
      };
      return axios(config)
      }
}



export default lawpayService